import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface ProductCardPricesParams {
  product_line_id: number;
  low_price_amount: number;
  low_price_container: string;
  high_price_amount?: number;
  high_price_container?: string;
}
export class ProductCardPricesEntity extends BaseEntityClass {
  product_line_id: number;
  low_price_amount: number;
  low_price_container: string;
  high_price_amount?: number;
  high_price_container?: string;

  constructor(params: ProductCardPricesParams) {
    super();
    this.type = "product_card_prices";
    this.entity_version = 2;
    this.product_line_id = params.product_line_id;
    this.low_price_amount = params.low_price_amount;
    this.low_price_container = params.low_price_container;
    this.high_price_amount = params.high_price_amount;
    this.high_price_container = params.high_price_container;
  }
}
